exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mylabel[data-v-196eabab]{width:100%;text-align:center;margin:auto;font-size:2.2em;font-style:italic;text-anchor:middle;color:#000}.card[data-v-196eabab]{height:100px;border-radius:10px;margin-bottom:10px;background-color:#d9dfe9}.text-xl[data-v-196eabab]{font-size:20px;font-weight:700}.text-md[data-v-196eabab]{font-size:15px;font-weight:700}.text-log[data-v-196eabab]{font-size:15px;font-style:italic}.container[data-v-196eabab]{margin-left:10px}.notif-panel[data-v-196eabab]{height:100%;max-height:300px;background-color:#d9dfe9;overflow-y:scroll;padding-bottom:10px;margin:10px;border-radius:10px}.notif-title[data-v-196eabab]{min-height:10%;background-color:#367fa9}.notif-content[data-v-196eabab]{height:90%;margin-top:10px}.notif-entry[data-v-196eabab]{min-height:30px;background-color:#fff;border-radius:10px;padding:10px;margin:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/views/dashboard/DashboardAdmin.vue?vue&type=style&index=0&id=196eabab&prod&scoped=true&lang=css&
// module id = 963
// module chunks = 0